import { render, staticRenderFns } from "./DoubleGraph.vue?vue&type=template&id=13827f9e&scoped=true&lang=pug"
import script from "./DoubleGraph.vue?vue&type=script&lang=js"
export * from "./DoubleGraph.vue?vue&type=script&lang=js"
import style0 from "./DoubleGraph.vue?vue&type=style&index=0&id=13827f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13827f9e",
  null
  
)

export default component.exports